export type PaginatedFilterOperator =
    "eq" |
    "ne" |
    "gt" |
    "gte" |
    "lt" |
    "lte" |
    "in" |
    "nin";

export const PAGINATED_FILTER_OPERATORS: PaginatedFilterOperator[] = [
    "eq",
    "ne",
    "gt",
    "gte",
    "lt",
    "lte",
    "in",
    "nin"
];

export interface PaginatedSort<TField extends string = string> {
    field: TField;
    direction: "asc" | "desc";
}

export interface PaginatedFilter<TField extends string = string, TValue = string | number | boolean | string[] | number[] | boolean[]> {
    field: TField;
    value: TValue;
    operator: PaginatedFilterOperator;
}

export interface PaginatedRequest<TField extends string = string, TValue = string | number | boolean | string[] | number[] | boolean[]> {
    offset: number;
    size: number;
    sort?: PaginatedSort<TField>;
    filters?: PaginatedFilter<TField, TValue>[];
}

export interface PaginatedResponse<TItem> {
    offset: number;
    size: number;
    total: number;
    items: TItem[];
}
